const worker_housing_uischema = {
    view: "main",
    title: "Worker Housing",
    entity: "Worker_Housing",
    linkBack: {
        name: 'Back to Profiles',
        link: '/dashboard/profiles',
    },
    button: {
        name: 'New Worker Housing',
        style: 'default',
    }
}

export default worker_housing_uischema;